import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams, withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import CreateOrEditCategoryModal from '../../components/@servierbar/modals/create-or-edit-category/create-or-edit-category.component';
import {
  setCreateCategoryModalData,
  setCreateItemModalData,
  setIsCheckoutModalOpen,
  setIsCreateCategoryModalOpen,
  setIsCreateItemModalOpen,
  setIsItemInfoModalOpen,
  setIsOrderInfoModalOpen,
  setIsOrderNotificationsModalOpen,
  setOrderInfoModalData,
  setOrderNotificationsModalData,
} from '../../redux/modal/modal.actions';
import CreateOrEditItemDataComponent from '../../components/@servierbar/modals/create-or-edit-item-data/create-or-edit-item-data.component';
import {
  filterMenuEntries,
  MenuEntryList,
  onSortEnd,
  SortableMenuEntryList,
} from './menu.service';
import StoreCoverCard from '../../components/@servierbar/cards/store-cover-card/store-cover-card.component';
import { Helmet } from 'react-helmet-async';
import BreadCrumbs from '../../components/@vuexy/breadCrumbs/BreadCrumb';
import {
  buildStoreManifestUrl,
  getStoreLink,
  getImageUrl,
  getLocalizedName,
  isAdminMode as _isAdminMode,
  setColorVars,
  updateTableSession,
  getCheckoutMethod,
  isOrderTypeValid,
  getSession,
  transformMenuEntries,
  trimText,
  getAvailableOrderTypesFromConfigs,
  allEnabledConfigsHavePosIntegration,
} from '../../utility/util/util.service';
import { config } from '../../configs/app.config';
import classnames from 'classnames';
import {
  addSearchStringsToMenuEntriesData,
  fetchMenuEntries,
  setAvailableOrderTypes,
  setCart,
  setCheckout,
  setOrder,
} from '../../redux/store/store.actions';
import ItemDataInfoModal from '../../components/@servierbar/modals/item-data-info/item-data-info.component';
import SelectAdditionsModal from '../../components/@servierbar/modals/select-additions/select-additions.component';
import CartModal from '../../components/@servierbar/modals/cart/cart.component';
import CheckoutModal from '../../components/@servierbar/modals/checkout/checkout.component';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import PickupStatusModal from '../../components/@servierbar/modals/pickup-status/pickup-status.component';
import CreateOrEditItemAdditionModal from '../../components/@servierbar/modals/create-or-edit-addition/create-or-edit-addition.component';
import EditMenuModal from '../../components/@servierbar/modals/edit-menu/edit-menu.component';
import ListAdditionsModal from '../../components/@servierbar/modals/list-additions/list-additions.component';
import TipModal from '../../components/@servierbar/modals/tip/tip.component';
import EditStoreLogo from '../../components/@servierbar/modals/edit-store-logo/edit-store-logo.component';
import Empty from '../errors/empty.component';
import { ArrowLeft, FilePlus, Flag, FolderPlus, SkipBack } from 'react-feather';
import { Button } from 'reactstrap';
import CreatePaymentMethodModal from '../../components/@servierbar/modals/create-payment-method/create-payment-method.component.js';
import TableCartModal from '../../components/@servierbar/modals/table-cart/table-cart.component';
import { useLocation } from 'react-router';
import { getStripeElementsConfig } from '../../configs/stripe-elements.config';
import { history } from '../../history';
import { notification } from '../../utility/notification/notification.service';
import { ServiceTimeProvider } from '../../context/service-time.context';
import TagManager from 'react-gtm-module/dist/TagManager';
import InfoModalComponent from '../../components/@servierbar/modals/info.component.js/info.component';
import OverlaySessionModal from '../../components/@servierbar/modals/overlay-session/overlaySession.js';
import TableReservationModal from '../../components/@servierbar/modals/table-reservation/table-reservation.component';
import ReservationReedemModal from '../../components/@servierbar/modals/reservation-reedem/reservation-redeem.component.js';
import ReservationUpcomingInfoModal from '../../components/@servierbar/modals/reservation-upcoming-info-modal/reservation-upcoming-info-modal';
import CreateOrEditItemAdditionGroupModal from '../../components/@servierbar/modals/create-or-edit-item-addition-group/create-or-edit-item-addition-group.component';
import DynamicTableComponent from '../../components/@servierbar/modals/dynamic-table-modal/dynamic-table.component.js';
import CategoryLevelBulkEditComponent from '../../components/@servierbar/modals/category-level-bulk-edit/category-level-bulk-edit.component';
import {
  CHECKOUT_METHOD_ORDER_ONLY,
  CHECKOUT_METHOD_PAY_AND_GO,
  ORDER_STATUS_PENDING,
  ROUTE_KIOSK,
  ROUTE_TABLE,
} from '../../utility/constants';
import TerminalCheckoutModal from '../../components/@servierbar/modals/checkout/terminal-checkout.component';
import OrderNotifications, {
  WHATSAPP_CHECKOUT_SESSION_KEY,
} from '../../components/@servierbar/modals/order-notifications-modal/order-notifications.component.js';
import { DateTime } from 'luxon';
import CallWaiterInfoModal from '../../components/@servierbar/modals/call-a-waiter/call-a-waiter-modal.component.js';
import SelfServiceTableSelectionModalComponent from '../../components/@servierbar/modals/self-service-table-selection-modal/self-service-table-selection-modal.component.js';
import OrderHintModal from '../../components/@servierbar/modals/order-hint/order-hint-component.js';
import {
  createGuest,
  getCustomerOrder,
  resumeCustomerOrder,
} from '../../utility/sb-api/sb-api.service';
import {
  hasLoadedOrderConfigs,
  resolveDynamicTableState,
} from '../../utility/dynamic-table/dynamic-table.state';

// Rebuilds a checkout cart from a server-side order, resolving each order-item
// addition back to its ItemAdditionGroupEntry via the loaded menu data. Returns
// null when the menu data is missing or an addition can't be resolved.
const buildCartFromOrder = (order, menuEntriesData) => {
  const itemDatasById = new Map();
  // menuEntriesData is the flat, search-ready itemData list
  // (addSearchStringsToMenuEntriesData -> extractData().flat()), so the
  // entries are itemDatas themselves rather than ItemMenuEntry wrappers.
  for (const itemData of menuEntriesData || []) {
    if (
      itemData?.type === 'ItemCategory' ||
      itemData?.type === 'InfoMenuEntry'
    ) {
      continue;
    }
    if (itemData?.id) itemDatasById.set(itemData.id, itemData);
  }

  const cart = [];
  for (const orderItem of order?.items || []) {
    const itemData = itemDatasById.get(orderItem?.itemData?.id);
    if (!itemData) return null;

    const additions = (orderItem?.additions || []).map((orderAddition) => {
      const entry = (itemData.additionGroups || [])
        .flatMap((group) =>
          (group.entries || []).map((e) => ({ entry: e, group })),
        )
        .find(
          ({ entry }) => entry.addition?.id === orderAddition?.itemAddition?.id,
        );
      if (!entry) return null;
      return {
        ...orderAddition,
        itemAddition: undefined,
        additionGroupEntry: {
          ...entry.entry,
          group: { ...entry.group, entries: undefined },
        },
      };
    });
    if (additions.some((addition) => !addition)) return null;

    cart.push({
      ...orderItem,
      itemData,
      additions,
    });
  }
  return cart;
};

// Derives a minimal checkout state from a server-side order (used when no
// locally saved checkout session is available).
const buildCheckoutFromOrder = (order) => ({
  orderType: order?.type,
  checkoutMethod: order?.checkoutMethod,
  cartComment: order?.cartComment,
  tip: order?.tip,
  discountCode: order?.discountCode?.code || null,
  deliveryAddressId: order?.deliveryAddressId,
  billingAddressId: order?.billingAddressId,
  notificationMethod: order?.notificationMethod,
  notificationRecipient: order?.notificationRecipient,
});

const Menu = ({
  me,
  store,
  table,
  allMenuEntries,
  allItemCategories,
  foodAllergensFilter,
  foodPreferencesFilter,
  foodIngredientsFilter,
  order,
  createPaymentMethodClientSecret,
  orders,
  cart,
  checkout,
  kiosk,
  availableOrderTypes,
  items,
  itemDatas,
  itemAdditions,
  itemAdditionGroups,
  menuEntriesData,
  foodAllergens,
  foodAdditives,
  foodPreferences,
  foodIngredients,

  setIsCreateItemModalOpen,
  setIsCreateCategoryModalOpen,
  setCreateItemModalData,
  setCreateCategoryModalData,
  addSearchStringsToMenuEntriesData,
  setOrderInfoModalData,
  setIsOrderInfoModalOpen,
  setIsOrderNotificationsModalOpen,
  setOrderNotificationsModalData,
  fetchMenuEntries,
  setCart,
  setCheckout,
  setIsCheckoutModalOpen,
  setOrder,
  setAvailableOrderTypes,
}) => {
  const intl = useIntl();
  const { slug, categoryId } = useParams();
  const location = useLocation();
  const { search } = location;

  const [menuEntries, setMenuEntries] = useState(null);
  const [isTableSessionModalOpen, setIsTableSessionModalOpen] = useState(false);
  const [isDynamicTableSession, setIsDynamicTableSession] = useState(false);
  const [tableReservationStartAt, setTableReservationStartAt] = useState(null);
  const [
    isReservationReedemModalOpen,
    setIsReservationReedemModalOpen,
  ] = useState(false);
  const [
    isReservationUpcomingInfoModalOpen,
    setIsReservationUpcomingInfoModalOpen,
  ] = useState(false);
  const [targetReservationId, setTargetReservationId] = useState(null);

  const stripePromise = useRef(null);

  const query = new URLSearchParams(search);
  const isAdminMode = _isAdminMode(me, slug);
  const isRootCategory = categoryId === undefined;
  const category = useMemo(
    () => allItemCategories?.find(({ id }) => id === categoryId),
    [allItemCategories, categoryId],
  );
  const categoryName = category && getLocalizedName(category, intl.locale);
  const areAnyFiltersSet =
    foodAllergensFilter?.length ||
    foodPreferencesFilter?.length ||
    foodIngredientsFilter?.length;
  const { tableSessionTimeoutMinutes } = store?.merchantProfile || {};
  // Hide items without posIntegrationRef only when ALL enabled order configs have POS integration
  const filterByPosIntegration = allEnabledConfigsHavePosIntegration(store);

  // pre-select the orderType and checkoutMethod
  // This effect runs when store or order configs change
  useEffect(() => {
    if (!store) return;

    // Don't proceed if configs aren't loaded yet (they're fetched asynchronously)
    if (!hasLoadedOrderConfigs(store)) {
      console.debug('Order configs not loaded yet, waiting...');
      return;
    }

    let orderTypes;

    // Determine available order types
    if (query?.has('orderType') && isOrderTypeValid(query.get('orderType'))) {
      // case: StoreLink with ?orderType=... query - force select an orderType
      orderTypes = [query.get('orderType')];
    } else {
      // case: StoreLink - get available order types from order configs
      // When on a table: inhouse + self-service
      // When not on a table: pickup (+ delivery/catering if enabled); self-service is kiosk/table-only
      orderTypes = getAvailableOrderTypesFromConfigs(store, table);
    }

    // Update available order types
    if (orderTypes?.length) {
      setAvailableOrderTypes(orderTypes);

      // Pre-select the first available orderType and its checkoutMethod
      const orderType = orderTypes[0];
      const checkoutMethod = getCheckoutMethod(
        orderType,
        store,
        table?.area,
        table,
      );

      if (orderType && checkoutMethod) {
        console.debug(
          `Pre-selected orderType="${orderType}" and checkoutMethod="${checkoutMethod}"`,
        );
        setCheckout({ orderType, checkoutMethod });
      } else if (orderType) {
        // Set orderType even without checkoutMethod to show prices
        console.debug(
          `Pre-selected orderType="${orderType}" without checkoutMethod`,
        );
        setCheckout({ orderType, checkoutMethod: null });
      }
    } else {
      console.debug('No orderType available - no enabled order configs found');
      setAvailableOrderTypes([]);
    }
  }, [
    store?.id,
    store?.pickupOrderConfig,
    store?.selfServiceOrderConfig,
    store?.inhouseOrderConfig,
    store?.deliveryOrderConfig,
    store?.cateringOrderConfig,
    table,
    kiosk,
  ]);

  // handle dynamic-table links
  useEffect(() => {
    const state = resolveDynamicTableState({
      pathname: window.location.pathname,
      store,
      isAdminMode,
    });

    if (state === 'idle') return;

    if (state === 'waiting') {
      // Order configs are fetched asynchronously and arrive after the store, so
      // wait rather than treating a not-yet-loaded config as "disabled".
      console.debug('Inhouse order config not loaded yet, waiting...');
      return;
    }

    console.debug('Found /dynamic-table link...');
    if (state === 'enabled') {
      setIsDynamicTableSession(true);
      console.debug('Starting DynamicTableSession...');
    } else {
      setIsDynamicTableSession(false);
      console.debug('DynamicTableLinks are disabled, skipping...');
    }
    history.replace(`/store/${store?.slug}${search || ''}`);
  }, [store, isAdminMode, search]);

  useEffect(() => {
    const now = new Date();
    const tableReservation = table?.reservations?.[0];
    if (tableReservation) {
      const reservationStartAt = new Date(tableReservation?.startAt);
      const reservationRedeemEnd = new Date(tableReservation?.startAt);
      reservationRedeemEnd.setMinutes(reservationRedeemEnd.getMinutes() + 15);
      setTableReservationStartAt(reservationStartAt);
      const isTableReservationActive =
        now > reservationStartAt && now < reservationRedeemEnd;

      setIsReservationReedemModalOpen(
        isTableReservationActive && !tableReservation?.redeemedAt,
      );
      setTargetReservationId(tableReservation?.id);
      if (!isTableReservationActive && !tableReservation?.redeemedAt) {
        setIsReservationUpcomingInfoModalOpen(true);
      }
    }
  }, [table]);

  // restore a tableSession/kioskSession after e.g. page reload. This will only be done in a timeframe of 1h.
  useEffect(() => {
    if (store && !table) {
      const tableSession = getSession('tableSession');

      // only restore the session if same Store
      if (tableSession?.storeId === store.id) {
        const lastActionAt = DateTime.fromISO(tableSession.lastActionAt);

        if (!lastActionAt?.isValid) {
          console.error('TableSession object is broken. Removing ...');
          localStorage.removeItem('tableSession');
          return;
        }

        // check whether tableSession has expired or not
        if (
          DateTime.now() <
          lastActionAt.plus({ minutes: tableSessionTimeoutMinutes || 60 }) // if lastAction was not more than <tableSessionTimeoutMinutes> ago
        ) {
          // user came back in time, redirect to TableLink to restart the session
          console.debug('Restoring Table Session...');
          history.replace(`${ROUTE_TABLE}/${tableSession.table.slug}`);
        } else {
          // session expired, so remove it
          localStorage.removeItem('tableSession');

          // show TableSession Modal if lastAction was not more than <tableSessionTimeoutMinutes> + 60min ago
          if (
            DateTime.now() <
            lastActionAt.plus({
              minutes: (tableSessionTimeoutMinutes || 60) + 60,
            })
          ) {
            setIsTableSessionModalOpen(true);
          }
        }
      } else {
        // different Store, so don't restore the TableSession
        localStorage.removeItem('tableSession');
      }
    }
  }, [store, table]);

  // update a tableSession on cart/checkout change
  useEffect(() => {
    if (table) updateTableSession();
  }, [cart, checkout]);

  // restore a kioskSession
  useEffect(() => {
    if (store && !kiosk) {
      const kioskSession = getSession('kioskSession');

      // only restore the session if same Store
      if (kioskSession?.storeId === store.id) {
        // redirect to KioskLink to restart the session
        console.debug('Restoring Kiosk Session...');
        history.replace(`${ROUTE_KIOSK}/${kioskSession.kiosk.id}${search}`);
      } else {
        // different Store, so don't restore the KioskSession
        localStorage.removeItem('kioskSession');
      }
    }
  }, [store, kiosk]);

  // check every minute if tableSession has expired
  useEffect(() => {
    if (table) {
      const interval = setInterval(() => {
        const tableSession = getSession('tableSession');

        if (tableSession) {
          // check whether tableSession has expired or not. Session length is 1h.
          const lastActionAt = DateTime.fromISO(tableSession.lastActionAt);
          if (
            lastActionAt.isValid &&
            DateTime.now() > lastActionAt.plus({ hour: 1 })
          ) {
            // session expired, show the TableSession Modal
            localStorage.removeItem('tableSession');
            setIsTableSessionModalOpen(true);
          }
        }
      }, 60 * 1000); // re-check every minute

      return () => {
        clearInterval(interval);
      };
    }
  }, []);

  // as soon as MenuEntries had been fetched and intl is ready, build the menuEntriesData
  useEffect(() => {
    // Wait for all required data to be loaded before transforming menu entries
    // Check that arrays are actually loaded (not null/undefined) - they can be empty arrays
    const dataLoaded = Array.isArray(items) && Array.isArray(itemDatas);

    if (allMenuEntries?.length > 0 && dataLoaded) {
      const menuEntriesWithData = transformMenuEntries({
        menuEntries: allMenuEntries,
        items: items || [],
        itemDatas: itemDatas || [],
        itemAdditions: itemAdditions || [],
        itemAdditionGroups: itemAdditionGroups || [],
        itemCategories: allItemCategories || [],
        foodAllergens: foodAllergens || [],
        foodAdditives: foodAdditives || [],
        foodPreferences: foodPreferences || [],
        foodIngredients: foodIngredients || [],
      });

      if (intl?.locale && menuEntriesWithData) {
        addSearchStringsToMenuEntriesData(menuEntriesWithData, intl.locale);
      }

      // Helper to get category ID from either object or string
      const getCategoryId = (cat) => {
        if (!cat) return null;
        return typeof cat === 'string' ? cat : cat.id;
      };

      // Filter menu entries based on allowed categories
      const filteredByArea =
        table?.area?.categories && !isAdminMode
          ? menuEntriesWithData.filter((menuEntry) =>
              table.area.categories
                .map(({ id }) => id)
                .includes(
                  getCategoryId(menuEntry?.category) ||
                    getCategoryId(menuEntry?.categoryEntry),
                ),
            )
          : menuEntriesWithData;

      // MenuEntries for current category.
      // Primary match: menuEntry.category matches the current category.
      // Secondary match (ItemMenuEntry only): item's own categories array
      // includes the current category — covers POS-imported items whose
      // menu-entry points to a different category.
      // Finally deduplicate so each item appears only once (duplicate menu
      // entries can exist when POS sync and the item-subscriber both
      // create an entry for the same item+category).
      const primaryMatched = filteredByArea.filter(({ category }) =>
        isRootCategory ? !category : getCategoryId(category) === categoryId,
      );
      const secondaryMatched = isRootCategory
        ? []
        : filteredByArea.filter((me) => {
            if (me.type !== 'ItemMenuEntry') return false;
            if (getCategoryId(me.category) === categoryId) return false;
            const cats = me.itemEntry?.categories;
            return (
              Array.isArray(cats) &&
              cats.some((c) => getCategoryId(c) === categoryId)
            );
          });

      // Deduplicate ItemMenuEntries by item id (keep first occurrence).
      const seenItemIds = new Set();
      const currentMenuEntries = [
        ...primaryMatched,
        ...secondaryMatched,
      ].filter((entry) => {
        if (entry.type !== 'ItemMenuEntry') return true;
        const itemId = entry.itemEntry?.id;
        if (!itemId) return true;
        if (seenItemIds.has(itemId)) return false;
        seenItemIds.add(itemId);
        return true;
      });

      // Filter by allergens, ingredients, and preferences
      const filteredMenuEntries = filterMenuEntries(
        currentMenuEntries,
        foodIngredientsFilter,
        foodAllergensFilter,
        foodPreferencesFilter,
      );

      setMenuEntries(filteredMenuEntries);
    } else if (allMenuEntries && allMenuEntries.length === 0) {
      // Only set empty if we know there are no menu entries (not just loading)
      setMenuEntries([]);
    }
  }, [
    allMenuEntries,
    items,
    itemDatas,
    itemAdditions,
    itemAdditionGroups,
    allItemCategories,
    foodAllergens,
    foodAdditives,
    foodPreferences,
    foodIngredients,
    intl,
    table,
    category,
    categoryId,
    foodAllergensFilter,
    foodIngredientsFilter,
    foodPreferencesFilter,
    isRootCategory,
    isAdminMode,
    addSearchStringsToMenuEntriesData,
  ]);

  useEffect(() => {
    if (store) {
      setColorVars(store);

      TagManager.dataLayer({
        dataLayer: {
          event: 'ViewStoreMenu ',
          customerProfileId: me?.requester?.customerProfile?.id,
          storeSlug: store?.slug,
        },
      });
    }
  }, [store]);

  useEffect(() => {
    const prevCheckoutSessionString = localStorage?.getItem(
      'prevCheckoutSession',
    );
    const prevCheckoutSession = JSON.parse(prevCheckoutSessionString);
    if (
      orders &&
      query?.has('orderId') &&
      (!query?.has('redirect_status') ||
        query?.get('redirect_status') === 'succeeded') &&
      // WhatsApp checkout resume is handled by its own effect below.
      query?.get('resume') !== 'checkout'
    ) {
      const id = query.get('orderId');
      const order = orders.find((order) => id === order.id);

      if (order) {
        setOrderInfoModalData({
          order,
          isInitial: query?.get('redirect_status') === 'succeeded',
        });
        setIsOrderInfoModalOpen(true);
      }
      localStorage.removeItem('prevCheckoutSession');
    }
    if (query?.get('redirect_status') === 'failed' && prevCheckoutSession) {
      notification(
        'error',
        'checkoutPaymentErrorNotification',
        true,
        'paymentError',
      );
      if (
        query?.get('payment_intent') ===
          prevCheckoutSession?.order?.payment?.paymentIntentId &&
        query?.get('orderId') === prevCheckoutSession?.order?.id &&
        query?.get('payment_intent_client_secret') &&
        prevCheckoutSession?.order?.payment?.clientSecret
      ) {
        setCheckout(prevCheckoutSession?.checkout);
        setCart(prevCheckoutSession?.cart);
        setOrder(prevCheckoutSession?.order);
        setIsCheckoutModalOpen(true);
      } else {
        localStorage.removeItem('prevCheckoutSession');
      }
    } else {
      localStorage.removeItem('prevCheckoutSession');
    }
  }, [orders]);

  // WhatsApp checkout resume: the customer taps the "finish your order" button
  // in the WhatsApp welcome message and lands here with
  // ?orderId=<id>&resume=checkout[&resumeToken=<token>]. Restores the exact
  // checkout state (saved when they opened WhatsApp) and reopens the
  // order-notifications modal so they can complete the checkout.
  //
  // The resumeToken lets the checkout continue even from a different browser
  // session (e.g. WhatsApp's in-app browser): the backend then claims the
  // order for the local session, so the customer doesn't need to know which
  // browser they originally ordered in.
  const resumedOrderIdRef = useRef(null);

  useEffect(() => {
    const orderId = query?.get('orderId');
    const isCheckoutResume = query?.get('resume') === 'checkout';
    const resumeToken = query?.get('resumeToken');
    if (!isCheckoutResume || !orderId || kiosk) return;

    // The cart is rebuilt from the server-side order against the loaded menu
    // data, so wait until it is available. The effect re-runs when it changes.
    if (!Array.isArray(menuEntriesData)) return;

    // One resume attempt per order (the resume token is single-use). Set the
    // ref before the async work so re-runs (e.g. menu data refresh) don't
    // claim or restore the order twice.
    if (resumedOrderIdRef.current === orderId) return;
    resumedOrderIdRef.current = orderId;

    const stripResumeParams = () => {
      // The resume params include a single-use credential — strip them from
      // the address bar so they don't linger in history, referrers or tabs.
      // This only runs once the checkout state has been restored, so a
      // menu-data reload can't lose them mid-restore.
      const remainingParams = new URLSearchParams(search);
      remainingParams.delete('orderId');
      remainingParams.delete('resume');
      remainingParams.delete('resumeToken');
      const nextSearch = remainingParams.toString();
      history.replace({
        pathname: location.pathname,
        search: nextSearch ? `?${nextSearch}` : '',
      });
    };

    const performResume = async () => {
      let freshOrder = null;
      try {
        freshOrder = await getCustomerOrder(orderId);
      } catch (err) {
        console.error('Order lookup failed for WhatsApp resume:', err);
      }

      if (!freshOrder && resumeToken) {
        // The order isn't owned by this session. The single-use resume token
        // is the capability: claim the order for the local session and
        // continue. A guest session is required first (fresh WebViews have
        // none yet).
        try {
          if (!localStorage.getItem('guestToken')) {
            await createGuest({ locale: intl?.locale?.split('-')[0] }, null);
          }
          freshOrder = await resumeCustomerOrder(orderId, resumeToken);
        } catch (resumeErr) {
          console.error('Failed to claim order via resume token:', resumeErr);
        }
      }

      if (!freshOrder) {
        // The order can't be looked up in this browser and no usable resume
        // token was available (expired/consumed). Tell the customer to reopen
        // the link where they ordered.
        notification('warning', 'resumeCheckoutError');
        return;
      }

      if (freshOrder?.status !== ORDER_STATUS_PENDING) {
        // The order was already submitted/completed meanwhile — show it
        // instead of resuming the checkout.
        setOrderInfoModalData({ order: freshOrder, isInitial: true });
        setIsOrderInfoModalOpen(true);
        stripResumeParams();
        return;
      }

      // Restore the exact checkout state persisted when the customer opened
      // WhatsApp (see order-notifications modal).
      let savedSession = null;
      try {
        savedSession = JSON.parse(
          localStorage?.getItem(WHATSAPP_CHECKOUT_SESSION_KEY) || 'null',
        );
      } catch {
        savedSession = null;
      }

      let cartToRestore = null;
      let checkoutToRestore = null;
      if (savedSession?.orderId === orderId) {
        cartToRestore = savedSession.cart ?? null;
        checkoutToRestore = savedSession.checkout ?? null;
        localStorage.removeItem(WHATSAPP_CHECKOUT_SESSION_KEY);
      }

      if (!cartToRestore) {
        // No saved session (e.g. cleared storage): rebuild the cart from the
        // server-side order via the loaded menu data.
        const rebuiltCart = buildCartFromOrder(freshOrder, menuEntriesData);
        if (!rebuiltCart) {
          // Menu data is loaded but the order can't be rebuilt (e.g. an item
          // was removed from the menu) — show the order instead.
          setOrderInfoModalData({ order: freshOrder, isInitial: true });
          setIsOrderInfoModalOpen(true);
          stripResumeParams();
          return;
        }
        cartToRestore = rebuiltCart;
        checkoutToRestore = buildCheckoutFromOrder(freshOrder);
      } else if (!checkoutToRestore) {
        checkoutToRestore = buildCheckoutFromOrder(freshOrder);
      }

      setOrder(freshOrder);
      setCart(cartToRestore);
      setCheckout(checkoutToRestore);

      // Reopen the exact modal the customer left: for order_and_pay the
      // notification-method prompt that hands over to checkout, for
      // order_only the prompt that finalizes the order, and for pay_and_go
      // (which has no notification prompt) the checkout itself.
      if (freshOrder.checkoutMethod === CHECKOUT_METHOD_PAY_AND_GO) {
        setIsCheckoutModalOpen(true);
      } else {
        setOrderNotificationsModalData({
          order: freshOrder,
          checkout: checkoutToRestore,
          proceedToCheckout:
            freshOrder.checkoutMethod !== CHECKOUT_METHOD_ORDER_ONLY,
          orderOnlyCheckout:
            freshOrder.checkoutMethod === CHECKOUT_METHOD_ORDER_ONLY,
        });
        setIsOrderNotificationsModalOpen(true);
      }
      stripResumeParams();
    };

    performResume();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuEntriesData, kiosk]);

  const pageTitle = `${store?.name || 'servier.bar'}${
    categoryName ? ' | ' + categoryName : ''
  }`;

  const openCreateCategoryModal = () => {
    setCreateCategoryModalData({
      parentCategoryId: categoryId || null,
    });
    setIsCreateCategoryModalOpen(true);
  };
  const openCreateItemModal = () => {
    setCreateItemModalData({
      isVariation: false,
      targetCategoryId: categoryId || null,
    });
    setIsCreateItemModalOpen(true);
  };

  return (
    <ServiceTimeProvider>
      <div className={classnames('px-0 h-100 w-100', { 'mt-3': isAdminMode })}>
        {store && (
          <Helmet
            title={pageTitle}
            link={[
              { rel: 'canonical', href: getStoreLink(store) },
              {
                rel: 'manifest',
                href: buildStoreManifestUrl(store, intl.locale),
              },
              {
                rel: 'apple-touch-icon',
                sizes: '180x180',
                href: getImageUrl(store?.logo, 'appleTouchIcon'),
              },
              {
                rel: 'icon',
                sizes: '32x32',
                href: getImageUrl(store?.logo, 'favicon32x32'),
              },
              {
                rel: 'icon',
                sizes: '16x16',
                href: getImageUrl(store?.logo, 'favicon16x16'),
              },
            ]}
          />
        )}

        {!isRootCategory && (
          <>
            {kiosk ? (
              <div className="d-flex align-content-center">
                <Link
                  to={
                    category?.parent
                      ? `/store/${slug}/${
                          typeof category.parent === 'string'
                            ? category.parent
                            : category.parent.id
                        }${search || ''}`
                      : `/store/${slug}${search || ''}`
                  }
                >
                  <Button
                    color="primary"
                    className="mb-1 text-center btn-sm btn btn-primary"
                  >
                    <FormattedMessage id="backLabel" />
                  </Button>
                </Link>
                <span className="font-medium-3 text-primary ml-1">
                  {trimText(
                    getLocalizedName(category, intl.locale),
                    30,
                    ' ...',
                  )}
                </span>
              </div>
            ) : (
              <BreadCrumbs
                category={category}
                isStoreOwnerMenu={isAdminMode}
                slug={store?.slug}
                title={categoryName}
                categories={allItemCategories}
              />
            )}
          </>
        )}

        {isRootCategory && (
          <StoreCoverCard store={store} isAdminMode={isAdminMode} />
        )}

        {menuEntries ? (
          menuEntries?.length > 0 ? (
            isAdminMode ? (
              <SortableMenuEntryList
                menuEntries={menuEntries}
                slug={slug}
                onSortEnd={(sortEnd) =>
                  onSortEnd(
                    menuEntries,
                    setMenuEntries,
                    sortEnd,
                    categoryId,
                    () => fetchMenuEntries(store?.menu?.id, isAdminMode),
                  )
                }
                axis={'xy'}
                // distance={5} // if not set it will ignore events like click
                pressDelay={300}
                useWindowAsScrollContainer={true}
                helperClass="opacity4"
              />
            ) : (
              <MenuEntryList
                filterByPosIntegration={filterByPosIntegration}
                menuEntries={menuEntries}
                slug={slug}
              />
            )
          ) : isAdminMode ? (
            <div className="d-flex justify-content-center align-items-center flex-column mt-3">
              <Flag size={60} className="primary mb-1" />
              <span className="text-center mx-2 font-medium-3 black mb-25">
                <FormattedMessage id="emptyMenuTitleStore" />
              </span>
              <span className="text-center mx-2 font-small-3 mb-2">
                <FormattedMessage id="emptyMenuSubTitleStore" />
              </span>
              <Button
                color="primary"
                className="mb-1"
                onClick={openCreateItemModal}
              >
                <FilePlus size={18} className="white mr-50" />
                <FormattedMessage id="addItem" />
              </Button>
              <Button
                color="primary"
                className="mb-1"
                onClick={openCreateCategoryModal}
              >
                <FolderPlus size={18} className="white mr-50" />
                <FormattedMessage id="addCategory" />
              </Button>
            </div>
          ) : areAnyFiltersSet ? (
            <Empty
              className="mt-2 mb-3"
              titleId="emptyMenuTitleUserFilter"
              subTitleId="emptyMenuSubTitleUserFilter"
            />
          ) : (
            <Empty
              className="mt-2 mb-3"
              titleId="emptyMenuTitleUser"
              subTitleId="emptyMenuSubTitleUser"
            />
          )
        ) : (
          /*dummy MenuEntries for Skeleton Load*/
          <MenuEntryList
            menuEntries={[
              { type: 'ItemMenuEntry' },
              { type: 'CategoryMenuEntry' },
              { type: 'ItemMenuEntry' },
            ]}
          />
        )}

        <ItemDataInfoModal />

        <InfoModalComponent />

        <DynamicTableComponent
          isOpen={isDynamicTableSession}
          closeModal={setIsDynamicTableSession}
        />

        <OverlaySessionModal
          isOpen={isTableSessionModalOpen}
          closeModal={setIsTableSessionModalOpen}
        />

        {isAdminMode === true && (
          <>
            {/*create new category modal*/}
            <CategoryLevelBulkEditComponent />
            <CreateOrEditCategoryModal />

            {/*create new item modal*/}
            <CreateOrEditItemDataComponent />

            {/*create new addition modal*/}
            <CreateOrEditItemAdditionModal />

            {/*list item additions modal*/}
            <ListAdditionsModal />

            {/*edit menu modal*/}
            <EditMenuModal />

            <EditStoreLogo />

            <CreateOrEditItemAdditionGroupModal />
          </>
        )}

        {isAdminMode === false && (
          <>
            <CartModal />
            <OrderNotifications />
            <OrderHintModal />
            {table && <TableCartModal />}
            <TableReservationModal />

            <TipModal />

            {/*select additions modal*/}
            <SelectAdditionsModal />

            {/*pickup status modal*/}
            <PickupStatusModal />
            <CallWaiterInfoModal />
            <ReservationReedemModal
              isOpen={isReservationReedemModalOpen}
              closeModal={() => {
                setIsReservationReedemModalOpen(false);
              }}
              titleId="confirm"
              targetReservationId={targetReservationId}
            />
            <SelfServiceTableSelectionModalComponent />
            <ReservationUpcomingInfoModal
              isOpen={isReservationUpcomingInfoModalOpen}
              closeModal={() => {
                setIsReservationUpcomingInfoModalOpen(false);
              }}
              startAt={tableReservationStartAt}
            />
            {/* checkout modal */}
            {order &&
              (order.kiosk &&
              kiosk &&
              (checkout?.selectedPaymentProcessor === 'terminal' ||
                !store?.paymentProcessor?.enabledPaymentMethods?.includes(
                  'twint',
                )) ? (
                <TerminalCheckoutModal />
              ) : (
                order?.payment?.clientSecret && (
                  <Elements
                    stripe={
                      new Promise((resolve) => {
                        if (stripePromise.current) {
                          resolve(stripePromise.current);
                        } else {
                          const stripePromise = loadStripe(
                            config.stripePublicKey,
                          );
                          stripePromise.current = stripePromise;
                          resolve(stripePromise);
                        }
                      })
                    }
                    options={{
                      ...getStripeElementsConfig(),
                      locale: intl.locale,
                      clientSecret: order?.payment?.clientSecret,
                    }}
                  >
                    <CheckoutModal />
                  </Elements>
                )
              ))}
            {createPaymentMethodClientSecret && (
              <Elements
                stripe={
                  new Promise((resolve) => {
                    if (stripePromise.current) {
                      resolve(stripePromise.current);
                    } else {
                      const stripePromise = loadStripe(config.stripePublicKey);
                      stripePromise.current = stripePromise;
                      resolve(stripePromise);
                    }
                  })
                }
                options={{
                  ...getStripeElementsConfig(),
                  locale: intl.locale,
                  clientSecret: createPaymentMethodClientSecret,
                }}
              >
                <CreatePaymentMethodModal />
              </Elements>
            )}
          </>
        )}
      </div>
    </ServiceTimeProvider>
  );
};

const mapStateToProps = (state) => ({
  me: state.me.me,
  store: state.store.store,
  table: state.store.table,
  allMenuEntries: state.store.menuEntries,
  allItemCategories: state.store.itemCategories,
  foodAllergensFilter: state.me.foodAllergensFilter,
  foodPreferencesFilter: state.me.foodPreferencesFilter,
  foodIngredientsFilter: state.me.foodIngredientsFilter,
  order: state.store.order,
  isOpen: state.modals.isCreatePaymentMethodModalOpen,
  createPaymentMethodClientSecret: state.me.createPaymentMethodClientSecret,
  orders: state.me.orders,
  cart: state.store.cart,
  checkout: state.store.checkout,
  kiosk: state.store.kiosk,
  availableOrderTypes: state.store.availableOrderTypes,
  items: state.store.items,
  itemDatas: state.store.itemDatas,
  itemAdditions: state.store.foodItemAdditions,
  itemAdditionGroups: state.store.additionGroups,
  menuEntriesData: state.store.menuEntriesData,
  foodAllergens: state.store.foodAllergens,
  foodAdditives: state.store.foodAdditives,
  foodPreferences: state.store.foodPreferences,
  foodIngredients: state.store.foodIngredients,
});

export default connect(mapStateToProps, {
  setIsItemInfoModalOpen,
  fetchMenuEntries,
  setIsCreateItemModalOpen,
  setIsCreateCategoryModalOpen,
  setCreateItemModalData,
  setCreateCategoryModalData,
  addSearchStringsToMenuEntriesData,
  setOrderInfoModalData,
  setIsOrderInfoModalOpen,
  setIsOrderNotificationsModalOpen,
  setOrderNotificationsModalData,
  setCart,
  setCheckout,
  setIsCheckoutModalOpen,
  setOrder,
  setAvailableOrderTypes,
})(withRouter(Menu));
